// TermsXsem is kept as a separate route (/terms-xsem) for backward-compatibility with existing
// links inside the subscription flow, but it shares the same legal content as the canonical
// /terms page. Single source of truth: Terms.tsx.
import Terms from './Terms'

export default Terms
